// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-system-notifications-request-access .fi-user-requests-list {
  padding: 0;
}
.fi-system-notifications-request-access .fi-user-requests-list .mat-mdc-card {
  padding: 0;
}
.fi-system-notifications-request-access .fi-user-requests-list .mat-mdc-card .fi-wrapper-table {
  /*.mat-column-PreferredBusinessUnitName, .mat-column-BusinessAreas, .mat-column-Roles {
    max-width: 12%;
  }

  .mat-column-ChangedOn {
    max-width: 20%;
  }*/
}
.fi-system-notifications-request-access .fi-user-requests-list .mat-mdc-card .fi-wrapper-table .mat-mdc-cell {
  cursor: pointer;
}
.fi-system-notifications-request-access .fi-user-requests-list .mat-mdc-card .fi-wrapper-table .mat-column-PreviewImage {
  max-width: 8%;
}`, "",{"version":3,"sources":["webpack://./Source/app/system-notifications/request-access/request-access.component.scss"],"names":[],"mappings":"AACI;EACI,UAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;AAEY;EASI;;;;;;IAAA;AAFhB;AANgB;EACI,eAAA;AAQpB;AALgB;EACI,aAAA;AAOpB","sourcesContent":[".fi-system-notifications-request-access {\r\n    .fi-user-requests-list {\r\n        padding: 0;\r\n\r\n        .mat-mdc-card {\r\n            padding: 0;\r\n\r\n            .fi-wrapper-table {\r\n                .mat-mdc-cell {\r\n                    cursor: pointer;\r\n                }\r\n\r\n                .mat-column-PreviewImage {\r\n                    max-width: 8%;\r\n                }\r\n\r\n                /*.mat-column-PreferredBusinessUnitName, .mat-column-BusinessAreas, .mat-column-Roles {\r\n          max-width: 12%;\r\n        }\r\n\r\n        .mat-column-ChangedOn {\r\n          max-width: 20%;\r\n        }*/\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
